import '@shared/scss/all.scss';
import vuetify from '@delivery/vuetify';
import Main from '@delivery/Main.vue';
import { createApp } from 'vue';
import router from './router';

const app = createApp(Main);
app.use(router);
app.use(vuetify);

router.isReady().then(() => app.mount('#app'));
